import {
    AddCircleOutlineOutlined as AddIcon,
    PhotoCamera as PhotoCameraIcon,
    Close as CloseIcon,
    DeleteOutlineRounded,
} from '@mui/icons-material';
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import { ModalProps } from 'types/common';
import { actionsStyles, avatarIconStyles, dialogStyles, avatarStyles, contentStyles } from './styles';

type Props = ModalProps & {
    image: string;
    defaultImage?: React.ReactNode;
    onAdd: () => void;
    onDelete: () => void;
};

export const PictureManagerModal = ({ image, defaultImage, isOpen, onClose, onAdd, onDelete }: Props) => {
    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth sx={dialogStyles}>
            <Box display="flex" justifyContent="space-between" px={4} py={3}>
                <Typography variant="h5" fontWeight={600}>
                    Profile Photo
                </Typography>
                <IconButton aria-label="close" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent sx={contentStyles}>
                <Avatar src={image} sx={avatarStyles}>
                    {defaultImage || <PhotoCameraIcon sx={avatarIconStyles} />}
                </Avatar>
            </DialogContent>
            <DialogActions sx={actionsStyles}>
                <Button startIcon={<AddIcon />} onClick={onAdd}>
                    Add photo
                </Button>
                <Button startIcon={<DeleteOutlineRounded />} onClick={onDelete} color="error">
                    Delete photo
                </Button>
            </DialogActions>
        </Dialog>
    );
};
